import { useChartStore } from '@/stores/chartStore';

function modifySymbolForMainPriceScaleInversionAndDividendAdjustments(shouldMainPriceScaleNowBeInverted: boolean) {
  const chartStore = useChartStore();

  if (!shouldMainPriceScaleNowBeInverted) {
    if (chartStore.isChartUnadjustedForDividends) {
      return `_${chartStore.symbol.slice(2)}`;
    }

    return chartStore.symbol.slice(1);
  }

  if (chartStore.isChartUnadjustedForDividends) {
    return `-_${chartStore.symbol.slice(1)}`;
  }

  return `-${chartStore.symbol}`;
}

export function updateIsMainPriceScaleInverted(shouldMainPriceScaleNowBeInverted: boolean) {
  const chartStore = useChartStore();

  if (shouldMainPriceScaleNowBeInverted === chartStore.isMainPriceScaleInverted) {
    return;
  }

  const newSymbol = modifySymbolForMainPriceScaleInversionAndDividendAdjustments(shouldMainPriceScaleNowBeInverted);

  if (newSymbol) {
    chartStore.$patch({ symbol: newSymbol });
  }
}
